<template>
<section class="list-columns p-4">

    <div class="max-w-3xl mx-auto">
        <SmoothLoader class="mt-8 mb-16" v-if="headline">
            <h2 v-html="headline" class="text-center text-white font-medium uppercase tracking-2 text-2xl vt:text-4xl"></h2>
        </SmoothLoader>
        <div class="flex flex-wrap -mx-4">
            <SmoothLoader v-if="left.length" class="w-full vt:w-1/2 px-4">
                <ul class="text-center">
                    <li class="text-gray-300 my-2 uppercase font-medium font-body text-lg" v-for="item in left" v-html="item"></li>
                </ul>
            </SmoothLoader>
            <SmoothLoader :delay="200" v-if="right.length" class="w-full vt:w-1/2 px-4">
                <ul class="text-center">
                    <li class="text-gray-300 my-2 uppercase font-medium font-body text-lg" v-for="item in right" v-html="item"></li>
                </ul>
            </SmoothLoader>
        </div>
    </div>

</section>
</template>

<script>
export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>